module.exports = __webpack_public_path__ + "img/数景云平台.ef852c9e.jpg";